import React from "react";
import { RangeSlider } from "./RangeSlider";

// Half of the bubble's 50px width: it stays inside the track at the ends
const BUBBLE_HALF_WIDTH = 25;

/**
 * Desktop slider for the share of the trade to close, with the value in a
 * bubble above the thumb and a 0% – 100% scale below.
 *
 * @param {object} props
 * @param {number} props.value percent
 * @param {(value: number) => void} props.onChange
 * @param {string} props.label accessible name
 * @param {number} props.min the lowest share that can be picked
 * @param {number} props.max
 * @param {number} props.step
 */
export const PercentSlider = ({ value, onChange, label, min, max, step }) => (
  <div className="partial-close__slider">
    <RangeSlider
      value={value}
      min={0}
      max={max}
      step={step}
      onChange={(next) => onChange(Math.max(min, next))}
      label={label}
      renderOverlay={(position) => (
        // Kept inside the track so it doesn't scroll the modal at 10% / 100%
        <span
          className="partial-close__bubble"
          style={{
            left: `clamp(${BUBBLE_HALF_WIDTH}px, ${position}%, calc(100% - ${BUBBLE_HALF_WIDTH}px))`,
          }}
        >
          {value}%
        </span>
      )}
    />

    <div className="partial-close__scale">
      <span>0%</span>
      <span>100%</span>
    </div>
  </div>
);
